import React from 'react';
import { ProductInput } from '../../components/input/ProductInput';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const ProductPicker = ({
  onChange,
  schema: { title = 'Product', description = 'Select a Product' },
  required,
  rawErrors,
  formData,
  idSchema,
  formContext,
}: FieldExtensionComponentProps<string>) => {
  return (
    <ProductInput
      label={title}
      helperText={description}
      error={rawErrors && rawErrors.length > 0 && !formData}
      required={required}
      id={idSchema?.$id}
      onChange={onChange}
      value={formData as string}
      team={formContext.formData.team}
    />
  );
};
